import fr from './fr.json';
import en from './en.json';

export const dictionaryList = { en, fr };

export const languageOptions = {
  en: 'English',
  fr: 'Français'
};
